import { render, staticRenderFns } from "./healthCert.vue?vue&type=template&id=056a3b0e&scoped=true&"
import script from "./healthCert.vue?vue&type=script&lang=js&"
export * from "./healthCert.vue?vue&type=script&lang=js&"
import style0 from "./healthCert.vue?vue&type=style&index=0&id=056a3b0e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056a3b0e",
  null
  
)

export default component.exports